module.exports = __webpack_public_path__ + "static/media/tele.df4368a0.jpg";